import { useContext } from "react";
import { ViewportContext } from "../components/managers";

const useViewport = () => {
	const { manageCallbacks, triggerGlobalRecompute, requestParentStats } =
		useContext(ViewportContext);

	return { manageCallbacks, triggerGlobalRecompute, requestParentStats };
};

export default useViewport;
